<template>
  <div class="sysmanage">
    <div class="toolbar">
      <el-button class="btn_other" icon="el-icon-plus" @click="addUser" >添加后台用户</el-button>
      <div>
        <el-input placeholder="请输入用户账号....." v-model="account" class="input-with-select" @keyup.enter.native="loadTableData" maxlength="32">
          <el-button slot="append" icon="el-icon-search" class="btn_main_color" @click="loadTableData"></el-button>
        </el-input>
      </div>
    </div>
    <div class="content_wrapper">
      <el-table
        v-loading="loading"
        :data="tableData"
        header-row-class-name="header-row-class-name"
        border
        :height="height"
        width="100%">
        <el-table-column
          prop="id"
          label="ID"
          align="center"
          width="100">
        </el-table-column>
        <el-table-column
          label="用户帐号名"
          align="center"
          prop="account"
          min-width="20%">
        </el-table-column>
        <el-table-column
          label="真实姓名"
          align="center"
          prop="realName"
          min-width="20%">
        </el-table-column>
        <el-table-column
          label="手机号码"
          align="center"
          prop="mobile"
          min-width="20%">
        </el-table-column>
        <el-table-column
          label="角色"
          align="center"
          prop="roleName"
          min-width="10%">
        </el-table-column>
        <el-table-column
          label="账户状态"
          align="center"
          prop="enabledDesc"
          width="120">
        </el-table-column>
        <el-table-column
          fixed="right"
          min-width="30%"
          label="操作">
          <template slot-scope="scope">
            <el-button  class="btn_other" size="small" @click="editUser(scope.row.id,scope.row)">编辑</el-button>
            <el-button  class="btn_other" size="small" @click="resetPWD(scope.row.id)">重置密码</el-button>
            <el-button  class="btn_disable" size="small" v-if="scope.row.enabled===true" @click="disableUser(scope.row.id,SysConstant.disable)">禁用</el-button>
            <el-button  class="btn_enable" size="small"  v-if="scope.row.enabled===false" @click="enableUser(scope.row.id,SysConstant.enable)">启用</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        class="my-pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 编辑框 -->
    <edit-dialog  v-model="sysDialogVisible" :id="id" :dataform="rowData" @success="editSuccess"></edit-dialog>
  </div>
</template>
<script type="text/babel">
import editDialog from './edit-dialog/index.vue'
import sysService from '@/service/sysService'
export default {
  components: {
    editDialog: editDialog
  },
  data () {
    return {
      loading: false,
      account: '',
      id: 0,
      rowData: {},
      sysDialogVisible: false,
      height: this.SysConstant.winHeight - 300,
      tableData: [],
      pageNumber: 0,
      pageSize: 20,
      total: 0
    }
  },
  mounted () {
    this.loadTableData()
  },
  methods: {

    addUser () {
      this.id = 0
      this.sysDialogVisible = true
    },
    editUser (id, row) {
      this.id = id
      this.rowData = row
      this.sysDialogVisible = true
    },
    editSuccess () {
      this.id = 0
      this.sysDialogVisible = false
      this.rowData = {}
      this.$message.success(this.SysConstant.success)
      this.loadTableData()
    },
    // 加载表格数据
    async loadTableData () {
      this.loading = true
      // 直接操作数据
      try {
        let data = await sysService.listUser({account: this.account, pageNumber: this.pageNumber, pageSize: this.pageSize})
        if (data && data.content) {
          let _data = data.content
          for (let item of _data) {
            item.enabledDesc = item.enabled ? '启用' : '已禁用'
            item.roleName = item.role.name
          }
          this.tableData = _data
          this.total = data.totalElements
        } else {
          this.tableData = []
        }
      } catch (e) {
        this.$message.error(e && e.msg)
      }
      this.loading = false
    },
    // 禁用
    async disableUser (id) {
      this.$confirm('此操作将禁用该用户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await sysService.disableUser(id)
        this.loadTableData()
        this.$message.success(this.SysConstant.success)
      }).catch((e) => {
     //   this.$message.error(e && e.msg)
      })
    },
    // 启用
    async enableUser (id) {
      try {
        await sysService.enabledUser(id)
        this.loadTableData()
        this.$message.success(this.SysConstant.success)
      } catch (e) {
        this.$message.error(e && e.msg)
      }
    },
    // 重置密码
    async resetPWD (id) {
      this.$confirm('此操作将重置该用户密码, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let data = await sysService.resetPWD(id)
        if (data) {
          // this.$alert('请记住新密码：' + data)
          this.$alert('请记住新密码：' + data, '新密码', {
            confirmButtonText: '确定',
            callback: action => {

            }
          })
        }
      }).catch((e) => {
     //   this.$message.error(e && e.msg)
      })
    },
    async handleSizeChange (val) {
      this.pageSize = val
      await this.loadTableData()
    },
    async  handleCurrentChange (val) {
      this.pageNumber = val
      await this.loadTableData()
    }
  }
}
</script>
<style scoped>
  .sysmanage {
    padding: 15px 10px;
  }
  .sysmanage .toolbar{
    padding-left: 20px;
    height: 74px;
    line-height: 74px;
    width: 100%;
    margin-bottom: 20px;
    background-color: #ffffff;
  }
  .sysmanage .toolbar>div{
    width: 400px;
    float: right;
    margin-right: 10px;
  }
  .sysmanage .toolbar .el-select {
    width: 130px;
  }
  .sysmanage .toolbar .input-with-select .el-input-group__prepend {
    background-color: #fff;
  }
  .sysmanage .content_wrapper{
    background-color: #ffffff;
    padding: 30px 10px 20px 20px;
  }

  .sysmanage .toolbar .el-select {
    width: 130px;
  }
  .sysmanage .toolbar .input-with-select{
    width: 400px;
  }
  .sysmanage .toolbar .input-with-select .el-input-group__prepend {
    background-color: #fff;

  }
</style>
<style type="text/css">

  .sysmanage .toolbar .el-input-group__append{
    background-color: #00AAFF;
    border: 1px solid #00AAFF;
    color: #ffffff;
    font-size: 16px;
  }

  .sysmanage .my-pagination *{
    color: #333333;
  }
  .sysmanage .my-pagination {
    border:solid 1px #DFE5F0;
    border-top: none;
    padding-left: 20px;
    padding-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/admin/sys-manage/index.vue